export const Investment_style = {
    parentBox: {
        position: "fixed",
        right: "0",
        left: "0"
    },
    paddings: {
        padding: '16px',
        overflow: "auto",
        height: "100vh"
    },
    container: {
        backgroundColor: 'background.Teritary',
        paddingLeft: "0px !important",
        paddingRight: "0px !important",
        "&::-webkit-scrollbar": {
            display: "none",
        },
        position: "relative",
        height: "calc(100vh - 10px)",
        overflow: "hidden"
    },
    Topnav: {
        position: 'sticky',
        top: 0,
        zIndex: 999
    }

}